/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/utils"/>
import * as $ from "jquery";

export function renderTemplate(templateName: string) {
    const templateScript = document.getElementById(templateName);
    if (!templateScript) {
        throw new Error(`Could not find template: ${templateName}`);
    }
    return $(templateScript.innerHTML);
}